import { routes } from "@bezoned/shared/routes.js";
import {
  Menu,
  MenuItemLink,
  MenuList,
  MenuPopover,
  MenuTrigger,
  SplitButton,
} from "@fluentui/react-components";
import { PersonFeedbackRegular } from "@fluentui/react-icons";

export const FeedbackButton = () => {
  const handleClick = () => {
    window.open(
      routes.external.bezoned.community,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Menu positioning="below-end">
      <MenuTrigger disableButtonEnhancement>
        <div
          data-feedback-button
          style={{
            position: "absolute",
            right: "20px",
            top: "20px",
            zIndex: 10,
          }}
        >
          <SplitButton
            appearance="primary"
            icon={<PersonFeedbackRegular />}
            menuButton={{
              "aria-label": "More options",
              menuIcon: {
                style: {
                  alignItems: "center",
                  display: "flex",
                  lineHeight: 0,
                },
              },
              style: {
                alignItems: "center",
              },
            }}
            primaryActionButton={{
              onClick: handleClick,
              style: {
                alignItems: "center",
              },
            }}
            style={{
              backgroundColor: "#696EB1",
            }}
          >
            Feedback
          </SplitButton>
        </div>
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          <MenuItemLink
            href="https://help.bezoned.com/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Help
          </MenuItemLink>
          <MenuItemLink
            href="https://community.bezoned.com/changelog"
            rel="noopener noreferrer"
            target="_blank"
          >
            Latest Updates
          </MenuItemLink>
          <MenuItemLink
            href="https://community.bezoned.com/roadmap"
            rel="noopener noreferrer"
            target="_blank"
          >
            Roadmap
          </MenuItemLink>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};
